<form [formGroup]="emailForm" (ngSubmit)="onSend()" autocomplete="off">
  <div class="container">
    <div id="publish-email" class="content">
      <div *ngIf="!xfer" style="padding: 50px 0px 75px; text-align:center">
        <h2>No related release notes found.</h2>
      </div>
      <div *ngIf="xfer" id="email-box" class="email-box">
        <div class="cancelButton">
          <button class="btn btn-outline-dark btn-sm" type="button" (click)="cancel()">X</button>
        </div>
        <div class="email-top">
          <div class="email-top-button col-2">
            <button class="btn btn-outline-dark btn-lg" type="submit">
              Send Email
            </button>
          </div>
          <div class="email-top-text col-10">
            <div class="form-row">
              <div class="form-group">
                <label class="col-form-label" style="margin-right: 10px;" for="recipients">To:</label>
                <input id="recipients" type="text" class="form-control" formControlName="To" />
              </div>
              <div *ngIf="To.invalid && (To.dirty || To.touched)" class="alert alert-danger" style="width: inherit;">
                <div *ngIf="To.errors.required">
                  Recipient(s) are/is required.
                </div>
                <div *ngIf="To.errors.validateEmailList" style="width: inherit;">
                  Email addresses must use the following format "username@domain.ext; user2@domain.ext;..."
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-form-label" style="margin-right: 10px;" for="subject">Subject:</label>
              <input id="subject" type="text" class="form-control" formControlName="Subject" />
            </div>
          </div>
        </div>
        <div id="email-content">
          <email-body [appName]='appName' [releaseDate]='releaseDate'></email-body>
        </div>
      </div>
    </div>
  </div>
</form>
